import { AlertTriangle, Info } from "lucide-react";
import { JSX } from "react";

import { EmploymentNotice } from "../../utils/manual-identity";
import { MANUAL_IDENTITY_LABELS } from "../../utils/messages";
import { EMPLOYMENT_ACK_TEST_ID } from "../../utils/decision-test-ids";

export const EMPLOYMENT_NOTICE_TEST_ID: string = "manual-identity-notice";

interface EmploymentNoticeBannerProps {
  notice: EmploymentNotice;
  acknowledged?: boolean;

  onAcknowledge?: (value: boolean) => void;
}

export function EmploymentNoticeBanner({
  notice,
  acknowledged,
  onAcknowledge,
}: EmploymentNoticeBannerProps): JSX.Element {
  const isWarning: boolean = notice.tone === "warning";
  const asksAcknowledge: boolean = isWarning && Boolean(onAcknowledge);

  return (
    <div
      data-testid={EMPLOYMENT_NOTICE_TEST_ID}
      role={isWarning ? "alert" : "status"}
      className={`flex gap-2 rounded-md border p-3 text-sm ${
        isWarning
          ? "border-yellow-500/40 bg-yellow-50 text-yellow-900"
          : "border-slate-300 bg-slate-50 text-slate-700"
      }`}
    >
      {isWarning ? (
        <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" aria-hidden="true" />
      ) : (
        <Info className="w-4 h-4 shrink-0 mt-0.5" aria-hidden="true" />
      )}
      <div className="flex flex-col gap-2">
        <span>{notice.text}</span>
        {asksAcknowledge && (
          <label className="flex cursor-pointer items-center gap-2 font-medium">
            <input
              type="checkbox"
              data-testid={EMPLOYMENT_ACK_TEST_ID}
              checked={Boolean(acknowledged)}
              onChange={(event): void => onAcknowledge?.(event.target.checked)}
            />
            <span>{MANUAL_IDENTITY_LABELS.ACKNOWLEDGE}</span>
          </label>
        )}
      </div>
    </div>
  );
}
